module.exports = __webpack_public_path__ + "static/media/featherImage.d67f0a8a.svg";